import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

function importTradeVerifyFirmReminderToast() {
    return import(
        /* webpackChunkName: "TradeVerifyFirmReminderToast" */
        '../../../TradeVerifyFirmReminderToast/TradeVerifyFirmReminderToastRenderer'
    ).then(({ TradeVerifyFirmReminderToastRenderer }) => TradeVerifyFirmReminderToastRenderer);
}

export const showTradeVerifyFirmReminder = ({ customActionType }) => dispatch => {
    importModuleAndRenderNotification({
        importFunc: importTradeVerifyFirmReminderToast,
        containerClassName: 'tradeVerifyFirmReminderToastContainer',
    });

    return dispatch({ type: customActionType.actionType });
};
